module.exports = __webpack_public_path__ + "static/media/ictmea.9a4697f8.PNG";